import { SiteEntryProps } from '@ixicare/resources';
import * as React from 'react';
import DrawToolMapContainer from '../container/DrawToolMapContainer';

interface DrawToolProps {
  site: SiteEntryProps;
  planeId: number;
}

const DrawTool: React.FC<DrawToolProps> = ({ site, planeId }) => {
  return <DrawToolMapContainer site={site} planeId={planeId} />;
};

export default DrawTool;
